import { types } from "mobx-state-tree";

const TutorLevelFactor = types.model("TutorLevelFactor", {
  tutor_level: types.optional(types.string, ""),
  factor: types.optional(types.number, 0),
});

const ExperienceFactor = types.model("ExperienceFactor", {
  experience: types.optional(types.string, ""),
  factor: types.optional(types.number, 0),
});

const RatingsFactor = types.model("RatingsFactor", {
  ratings: types.optional(types.string, ""),
  factor: types.optional(types.number, 0),
});

const ClientsFactor = types.model("ClientsFactor", {
  no_of_clients: types.optional(types.string, ""),
  factor: types.optional(types.number, 0),
});

const RecommendedFactor = types.model("RecomendedFactor", {
  name: types.optional(types.string, ""),
  factor: types.optional(types.number, 0),
});

export const FactorStore = types.model("Factors", {
  tutorLevelFactor: types.optional(types.array(TutorLevelFactor), []),
  experienceFactor: types.optional(types.array(ExperienceFactor), []),
  ratingsFactor: types.optional(types.array(RatingsFactor), []),
  noOfClientsFactor: types.optional(types.array(ClientsFactor), []),
  recommendedFactor: types.optional(types.array(RecommendedFactor), []),
});
